import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/img/paas.png'


const _hoisted_1 = { class: "headSearch" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = { class: "headPath" }
const _hoisted_4 = { class: "path" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "navBox" }
const _hoisted_8 = { class: "treeBox" }
const _hoisted_9 = {
  key: 0,
  class: "lastlvIcon"
}
const _hoisted_10 = {
  key: 0,
  class: "searchBox"
}
const _hoisted_11 = { class: "headClose" }
const _hoisted_12 = { class: "searchBtn" }
const _hoisted_13 = {
  key: 0,
  class: "searchResult"
}
const _hoisted_14 = {
  key: 1,
  class: "searchResult1"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "searchItemName" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickLogo && _ctx.handleClickLogo(...args))),
        style: {"width":"64px"},
        src: _imports_0,
        alt: "logo"
      }),
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAwsSix && _ctx.openAwsSix(...args))),
          class: "aws6Enter"
        }, "访问6平台文档"),
        _createElementVNode("i", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchShow=true)),
          style: {"font-size":"20px"},
          class: "iconfont"
        }, "")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("i", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navClick && _ctx.navClick(...args))),
        class: "iconfont spread"
      }, ""),
      _createElementVNode("span", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPath, (item, i) => {
          return (_openBlock(), _createElementBlock("span", {
            onClick: ($event: any) => (_ctx.handlePathItem(item)),
            key: item.id
          }, [
            _createTextVNode(_toDisplayString(item.name) + " ", 1),
            (_ctx.currentPath.length-1!=i)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, ">"))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.navShow,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.navShow) = $event)),
      onOpen: _ctx.openPopUp,
      "close-on-popstate": true,
      "close-on-click-overlay": false,
      closeable: "",
      position: "left",
      style: { height: '100%',width:'80%',minWidth:'250px',maxWidth:'500px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_tree, {
              ref: "treeRef",
              data: _ctx.treeData,
              onNodeClick: _ctx.handleNodeClick,
              "current-node-key": _ctx.currentNode,
              "node-key": "id",
              props: _ctx.defaultProps,
              height: 308
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["treeLine", _ctx.currentNode==data.id?'activeNode':''])
                }, [
                  (data.children?.length<=0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "nodeMes",
                    style: _normalizeStyle({'font-weight':data.pid=='0'?'600':'400'})
                  }, _toDisplayString(node.label), 5)
                ], 2)
              ]),
              _: 1
            }, 8, ["data", "onNodeClick", "current-node-key", "props"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onOpen"]),
    (_ctx.searchShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("i", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeSearch && _ctx.closeSearch(...args))),
              class: "iconfont closeSearch"
            }, "")
          ]),
          _createVNode(_component_el_popover, {
            placement: "bottom",
            trigger: "manual",
            "popper-class": "searchInputPopover",
            visible: _ctx.showPopover,
            "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showPopover) = $event)),
            disabled: _ctx.inputValue=='',
            teleported: false,
            style: {"width":"auto !important"}
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.inputValue,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputValue) = $event)),
                  placeholder: "请输入关键词进行搜索",
                  "prefix-icon": _ctx.Search,
                  clearable: "",
                  onFocus: _ctx.inputClick,
                  onClick: _withModifiers(_ctx.inputClick, ["stop"]),
                  onInput: _ctx.changeSearch
                }, {
                  prefix: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("i", {
                      class: "iconfont",
                      style: {"font-size":"24px","color":"#918f8f"}
                    }, "", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue", "prefix-icon", "onFocus", "onClick", "onInput"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "popoverBox",
                style: _normalizeStyle({'max-height':_ctx.searchListHeight+'px'})
              }, [
                (_ctx.searchList.length!=0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.searchTotal) + "个与“" + _toDisplayString(_ctx.inputValue) + "”相关的结果", 1))
                  : _createCommentVNode("", true),
                (_ctx.searchList.length==0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "未检测到搜索结果"))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onClick: _withModifiers(($event: any) => (_ctx.handleSelect(item)), ["stop"]),
                    key: item.id,
                    class: "searchItem"
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "circle" }, null, -1)),
                      _createElementVNode("div", {
                        class: "mes",
                        innerHTML: item.current?.name
                      }, null, 8, _hoisted_17)
                    ]),
                    _createElementVNode("div", {
                      class: "searchItemMes",
                      innerHTML: item.content
                    }, null, 8, _hoisted_18)
                  ], 8, _hoisted_15))
                }), 128))
              ], 4)
            ]),
            _: 1
          }, 8, ["visible", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}